var map = {
	"./gerencia_ai/dashboard-banner.png": 436,
	"./gerencia_ai/illustration-404.png": 1202,
	"./gerencia_ai/image-forgot.png": 1922,
	"./gerencia_ai/image-login.png": 8948,
	"./gerencia_ai/image-signup.png": 2335,
	"./gerencia_ai/logo-dark.svg": 4787,
	"./gerencia_ai/logo-full.svg": 6632,
	"./gerencia_ai/logo-light.svg": 9321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3828;